export type IActions = {
  payload: any;
  type: string;
};

export type StoreContextType = {
  states: {
    height: number;
    darkMode: boolean;
  };
  actions: {
    setHeight: (data: number) => void;
    setDarkMode: (isDark: boolean) => void;
  };
};

export const defaultStoreValues = {
  states: {
    height: 850,
    darkMode: true,
  },
  actions: {
    setHeight: (): void => {},
    setDarkMode: (): void => {},
  },
};
